import { storagePublicBaseUrl } from '../config/env';

const BUCKET_PUBLIC_PATH = '/storage/v1/object/public/contact-photos/';

/**
 * Normalizuje link lub ścieżkę pliku do pełnego publicznego URL (mobilka używa photo_url jako uri).
 * @param {string} input — pełny URL z Supabase lub sama nazwa pliku w bucketcie contact-photos
 * @returns {string|null}
 */
export function normalizeContactPhotoUrl(input) {
  const trimmed = (input || '').trim();
  if (!trimmed) return null;

  const withoutQuery = trimmed.split('?')[0].trim();

  if (withoutQuery.startsWith('http://') || withoutQuery.startsWith('https://')) {
    return withoutQuery;
  }

  const cleanPath = withoutQuery.replace(/^\//, '');
  const base = (storagePublicBaseUrl || '').replace(/\/$/, '');
  if (!base) {
    return cleanPath;
  }
  return `${base}${BUCKET_PUBLIC_PATH}${cleanPath}`;
}

/** Czy wygląda na sensowny link / ścieżkę zdjęcia kontaktu. */
export function isValidContactPhotoInput(input) {
  const normalized = normalizeContactPhotoUrl(input);
  if (!normalized) return false;
  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized.includes('contact-photos') || /\.(jpe?g|png|webp|gif)$/i.test(normalized);
  }
  return /\.(jpe?g|png|webp|gif)$/i.test(normalized);
}
